import React from "react";
import cryptosafeads from "./Cryptosafeads.png";
import "./Ads1200100.css";

const Ads1200100 = () => {
  const handleClick = () => {
    window.open("https://cryptosafe.co.il", "_blank");
  };

  return (
    <div className="ads-container" onClick={handleClick}>
      <img src={cryptosafeads} alt="CryptoSafe Ad" className="ads-image" />
    </div>
  );
};

export default Ads1200100;